
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5690',
  depVersions: {
  "data-privacy-request-ui": "static-1.5690",
  "client-types": "static-1.488",
  "data-fetching-client": "static-1.9832",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8196",
  "hub-http-shared-msw-handlers": "static-1.10396",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11649",
  "I18n": "static-7.1645",
  "jasmine-runner": "static-1.6629",
  "quartz": "static-1.7261",
  "react-dlb": "static-1.83",
  "rpc-client-utils": "static-1.4832",
  "ui-components-test-utils": "static-1.5786",
  "UIComponents": "static-3.8595",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.89",
  "foundations-assets": "static-1.5047",
  "foundations-components": "static-1.8274",
  "foundations-components-test-utils": "static-1.5757",
  "foundations-theming": "static-1.4613",
  "hub-http": "static-1.6394",
  "quartz-config": "static-1.1039",
  "quartz-core": "static-1.6480",
  "quartz-routing": "static-1.691",
  "quick-fetch": "static-1.4042",
  "raven": "static-3.5925",
  "react": "static-7.189",
  "react-rhumb": "static-1.16875",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11323",
  "usage-tracker": "static-1.7526",
  "usage-tracker-anonymous": "static-1.5943",
  "usage-tracker-core": "static-1.7376",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3525",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3538",
  "quartz-webpack": "static-1.3485",
  "bend-plugin-quartz-routing": "static-1.339",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "HeadJS": "static-2.777",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3307",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "ts-schema": "static-1.4205",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "react-utils": "static-2.5466",
  "StyleGuideUI": "static-3.491",
  "jasmine": "static-4.4498",
  "bend-plugin-chirp-manifest": "static-1.242",
  "chirp-fetch": "static-1.2062",
  "HubStyle": "static-2.11956",
  "ui-addon-draggable": "static-3.4932",
  "cssUtils": "static-1.842",
  "hs-story-utils": "static-1.9599",
  "icons": "static-2.665",
  "react-create-root-preference": "static-1.45",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1205",
  "bend-plugin-foundations-components": "static-1.4543",
  "floating-ui": "static-1.60",
  "foundations-theming-specialty": "static-1.2329",
  "react-aria": "static-1.69",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2282",
  "ui-fonts": "static-1.911",
  "foundations-components-legacy": "static-1.1299",
  "bend-plugin-foundations-theming": "static-1.3096",
  "foundations-theming-base": "static-1.3598",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.206",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.852",
  "hubspotter-http": "static-1.4776",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.936",
  "quartz-head": "static-1.926",
  "quartz-i18n": "static-1.936",
  "quartz-test": "static-1.936",
  "quartz-tracking": "static-1.640",
  "trellis-components": "static-1.2301",
  "usage-tracker-container": "static-1.7516",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3308",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.74",
  "sassPrefix": "static-1.159",
  "hubspotter-http-shared-msw-handlers": "static-1.10394",
  "usage-tracker-session-replay": "static-1.5212",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1123",
  "tanstack-virtual": "static-1.33",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5690",
  "client-types": "/client-types/static-1.488",
  "data-fetching-client": "/data-fetching-client/static-1.9832",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8196",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10396",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11649",
  "I18n": "/I18n/static-7.1645",
  "jasmine-runner": "/jasmine-runner/static-1.6629",
  "quartz": "/quartz/static-1.7261",
  "react-dlb": "/react-dlb/static-1.83",
  "rpc-client-utils": "/rpc-client-utils/static-1.4832",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5786",
  "UIComponents": "/UIComponents/static-3.8595",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "foundations-assets": "/foundations-assets/static-1.5047",
  "foundations-components": "/foundations-components/static-1.8274",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5757",
  "foundations-theming": "/foundations-theming/static-1.4613",
  "hub-http": "/hub-http/static-1.6394",
  "quartz-config": "/quartz-config/static-1.1039",
  "quartz-core": "/quartz-core/static-1.6480",
  "quartz-routing": "/quartz-routing/static-1.691",
  "quick-fetch": "/quick-fetch/static-1.4042",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.189",
  "react-rhumb": "/react-rhumb/static-1.16875",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11323",
  "usage-tracker": "/usage-tracker/static-1.7526",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5943",
  "usage-tracker-core": "/usage-tracker-core/static-1.7376",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3525",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3538",
  "quartz-webpack": "/quartz-webpack/static-1.3485",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.339",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "HeadJS": "/HeadJS/static-2.777",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3307",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "ts-schema": "/ts-schema/static-1.4205",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "react-utils": "/react-utils/static-2.5466",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "jasmine": "/jasmine/static-4.4498",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.242",
  "chirp-fetch": "/chirp-fetch/static-1.2062",
  "HubStyle": "/HubStyle/static-2.11956",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4932",
  "cssUtils": "/cssUtils/static-1.842",
  "hs-story-utils": "/hs-story-utils/static-1.9599",
  "icons": "/icons/static-2.665",
  "react-create-root-preference": "/react-create-root-preference/static-1.45",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1205",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4543",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2329",
  "react-aria": "/react-aria/static-1.69",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2282",
  "ui-fonts": "/ui-fonts/static-1.911",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1299",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3096",
  "foundations-theming-base": "/foundations-theming-base/static-1.3598",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.206",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.852",
  "hubspotter-http": "/hubspotter-http/static-1.4776",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.936",
  "quartz-head": "/quartz-head/static-1.926",
  "quartz-i18n": "/quartz-i18n/static-1.936",
  "quartz-test": "/quartz-test/static-1.936",
  "quartz-tracking": "/quartz-tracking/static-1.640",
  "trellis-components": "/trellis-components/static-1.2301",
  "usage-tracker-container": "/usage-tracker-container/static-1.7516",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3308",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.74",
  "sassPrefix": "/sassPrefix/static-1.159",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10394",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5212",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1123",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
